var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-wrapper"},[_c('b-tabs',{attrs:{"fill":""}},[_c('b-tab',{attrs:{"title":"Prompts"}},[_c('PromptList')],1),_c('b-tab',{attrs:{"title":"Variables"}},[_c('VariableList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }